import { ChangeDetectionStrategy, Component, InputSignal, input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

export type BadgeSize = 'large' | 'small' | 'extra-small' | 'dot' | 'dot-large'

export type BadgeColour = 'default' | 'accent' | 'alert' | 'grey' | 'informative'

export type BadgeType = 'attached' | 'standalone'

@Component({
  selector: 'td-wb-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
  imports: [NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.td-wb-badge--accent]': 'colour() === "accent"',
    '[class.td-wb-badge--alert]': 'colour() === "alert"',
    '[class.td-wb-badge--grey]': 'colour() === "grey"',
    '[class.td-wb-badge--informative]': 'colour() === "informative"',
    '[class.td-wb-badge--attached]': 'type() === "attached"',
    '[class.td-wb-badge--standalone]': 'type() === "standalone"',
    '[class.td-wb-badge--standalone-xs]': 'type() === "standalone" && size() === "extra-small"',
    '[class.td-wb-badge--extra-small-single]': 'size() === "extra-small" && number() <= 9'
  }
})
export class BadgeComponent {
  private static readonly DEFAULT_LARGE_LIMIT: number = 99;
  text: InputSignal<string | undefined> =  input<string>();
  number: InputSignal<number | undefined> =  input<number>();
  limit: InputSignal<number | undefined> =  input<number>();
  showIndicator: InputSignal<boolean> =  input<boolean>(false);
  size: InputSignal<BadgeSize> =  input<BadgeSize>('small');
  colour: InputSignal<BadgeColour> =  input<BadgeColour>('default');
  type: InputSignal<BadgeType> =  input<BadgeType>('attached');

  getBadgeText(): string {
    return this.text() !== undefined ? this.text() : this.getBadgeTextFromNumber();
  }

  private getBadgeTextFromNumber(): string | undefined {
    if (this.number() === undefined || this.number() <= 0) {
      return '0';
    } else if ((this.limit() !== undefined && this.number() > this.limit()) ||
      (this.size() === 'large' && this.limit() === undefined && this.number() > BadgeComponent.DEFAULT_LARGE_LIMIT)) {
      return this.limit() !== undefined ? this.limit()?.toString() + '+' : BadgeComponent.DEFAULT_LARGE_LIMIT.toString() + '+';
    } else {
      return this.number()?.toString();
    }
  }
}
